import { defineComponent as p, computed as c, defineAsyncComponent as n, createBlock as T, openBlock as a, resolveDynamicComponent as l, mergeProps as s } from "vue";
const S = /* @__PURE__ */ p({
  __name: "TnProductIcon",
  props: {
    name: {},
    size: { default: "m" }
  },
  setup(m) {
    const o = m, i = c(() => o.size === "xs" ? "48px" : o.size === "s" ? "64px" : o.size === "m" ? "96px" : o.size === "l" ? "120px" : o.size === "xl" ? "180px" : o.size === "2xl" ? "240px" : "96px"), r = {
      TnIcon2G: n(() => import("./TnIcon2-g-DElukbT4.js")),
      TnIcon3G: n(() => import("./TnIcon3-g-DiPjvKFz.js")),
      TnIcon3GSIM: n(() => import("./TnIcon3-gsim-BMrPgTZv.js")),
      TnIcon3GSIMInactive: n(() => import("./TnIcon3-gsim-inactive-Cd7ZGqj0.js")),
      TnIcon4G: n(() => import("./TnIcon4-g-D054swff.js")),
      TnIcon4GPluss: n(() => import("./TnIcon4-g-pluss-BWr2NT0s.js")),
      TnIcon4GSIM: n(() => import("./TnIcon4-gsim-h3ZrGpJq.js")),
      TnIcon4GSIMGold: n(() => import("./TnIcon4-gsim-gold-B2D4QL1i.js")),
      TnIcon4GSIMinactive: n(() => import("./TnIcon4-gsi-minactive-CvVo8Mma.js")),
      TnIcon5G: n(() => import("./TnIcon5-g-BUYE64H3.js")),
      TnIcon5GSIM: n(() => import("./TnIcon5-gsim-CXfcXKhq.js")),
      TnIcon5GSIMinactive: n(() => import("./TnIcon5-gsi-minactive-IcbfVLAU.js")),
      TnIconAlltidpaNettGaranti: n(() => import("./TnIconalltidpa-nett-garanti-D4l3r3D_.js")),
      TnIconBedriftTale: n(() => import("./TnIconbedrift-tale-DdxEXimA.js")),
      TnIconBedriftTotal: n(() => import("./TnIconbedrift-total-gyJCows6.js")),
      TnIconBedriftTotalAnsatt: n(() => import("./TnIconbedrift-total-ansatt-Cb6k6znr.js")),
      TnIconBedriftTotalY: n(() => import("./TnIconbedrift-total-y-B4aFdVrC.js")),
      TnIconBetalSelvDataBoost: n(() => import("./TnIconbetal-selv-data-boost-nMNvXKgi.js")),
      TnIconBetalSelvDataBoostUtland: n(() => import("./TnIconbetal-selv-data-boost-utland-BERb4v9Z.js")),
      TnIconBetalSelvEkstraPakke: n(() => import("./TnIconbetal-selv-ekstra-pakke-iyVeAPL1.js")),
      TnIconBetalSelvHastighet: n(() => import("./TnIconbetal-selv-hastighet-Cnta1VAR.js")),
      TnIconBlokkerAnrop: n(() => import("./TnIconblokker-anrop-BkK_NRSk.js")),
      TnIconBredbandstelefoni: n(() => import("./TnIconbredbandstelefoni-Cu2CmU2o.js")),
      TnIconCustom: n(() => import("./TnIconcustom-61zHmFFb.js")),
      TnIconDataBoost: n(() => import("./TnIcondata-boost-sNLWm3N7.js")),
      TnIconDataBoostUtland: n(() => import("./TnIcondata-boost-utland-geP7qcAm.js")),
      TnIconDatagrense: n(() => import("./TnIcondatagrense-CJ06lk34.js")),
      TnIconDatakontroll: n(() => import("./TnIcondatakontroll-DqsBRxxf.js")),
      TnIconDatakort: n(() => import("./TnIcondatakort-C1BozpCb.js")),
      TnIconDataReload: n(() => import("./TnIcondata-reload-Du2_fooy.js")),
      TnIconDataRollover: n(() => import("./TnIcondata-rollover-CNAYUgrs.js")),
      TnIconDataSIM: n(() => import("./TnIcondata-sim-DZ42DOVo.js")),
      TnIconDatasperreUtland: n(() => import("./TnIcondatasperre-utland-C6U04bk5.js")),
      TnIconEkstraPakke: n(() => import("./TnIconekstra-pakke-lEsN9zIo.js")),
      TnIconEkstraSIM: n(() => import("./TnIconekstra-sim-DYCxLaws.js")),
      TnIconEnkel8GB: n(() => import("./TnIconenkel8-gb-EjFWHwe9.js")),
      TnIconeSIM: n(() => import("./TnIcone-sim-CUYWik5s.js")),
      TnIconEUInkludert: n(() => import("./TnIconeu-inkludert-Daju9y8I.js")),
      TnIconFallbackAgreements: n(() => import("./TnIconfallback-agreements-CIB1kW2s.js")),
      TnIconFallbackCoverage: n(() => import("./TnIconfallback-coverage-B6vVfPnB.js")),
      TnIconFallbackInternet: n(() => import("./TnIconfallback-internet-DsCZu8eJ.js")),
      TnIconFallbackPhonePlan: n(() => import("./TnIconfallback-phone-plan-CP_X7_Sw.js")),
      TnIconFallbackPhonePlanAddOn: n(() => import("./TnIconfallback-phone-plan-add-on-DAecmfgh.js")),
      TnIconFallbackSIM: n(() => import("./TnIconfallback-sim-M_d26Yyw.js")),
      TnIconFallbackSIMInactive: n(() => import("./TnIconfallback-sim-inactive-ssmL33OV.js")),
      TnIconFallbackTelenorSpecific: n(() => import("./TnIconfallback-telenor-specific-C84WacPL.js")),
      TnIconFamilie: n(() => import("./TnIconfamilie-CJ0s2KX-.js")),
      TnIconFamilieBonus: n(() => import("./TnIconfamilie-bonus-B-N8QKK0.js")),
      TnIconFasttelefoni: n(() => import("./TnIconfasttelefoni-DDKu9QSJ.js")),
      TnIconFiber: n(() => import("./TnIconfiber-CfXVpBl5.js")),
      TnIconFleksi: n(() => import("./TnIconfleksi-682bu6B2.js")),
      TnIconFlyt20: n(() => import("./TnIconflyt20-BTofc7_C.js")),
      TnIconFlyt5: n(() => import("./TnIconflyt5-xbaP3BeZ.js")),
      TnIconFlyt50: n(() => import("./TnIconflyt50-D8upYS1D.js")),
      TnIconFlytL: n(() => import("./TnIconflyt-l-Cpo_tXVz.js")),
      TnIconFlytM: n(() => import("./TnIconflyt-m-DDyNBXpm.js")),
      TnIconFlytM20: n(() => import("./TnIconflyt-m20-CJFimixk.js")),
      TnIconFlytMPluss: n(() => import("./TnIconflyt-m-pluss-BejdUTXq.js")),
      TnIconFlytS: n(() => import("./TnIconflyt-s-m1WLwVyO.js")),
      TnIconFlytXS: n(() => import("./TnIconflyt-xs-DLrXLMe2.js")),
      TnIconForhandler: n(() => import("./TnIconforhandler-D7G-xpXQ.js")),
      TnIconFornoydGaranti: n(() => import("./TnIconfornoyd-garanti-BHSDfmXU.js")),
      TnIconForsikring: n(() => import("./TnIconforsikring-CJNVFLbi.js")),
      TnIconFreebie: n(() => import("./TnIconfreebie-Dt0ERu-j.js")),
      TnIconFreeMMS: n(() => import("./TnIconfree-mms-CeAxZTLP.js")),
      TnIconFriBrukSkandinavia: n(() => import("./TnIconfri-bruk-skandinavia-CCuxUQRD.js")),
      TnIconFrihet: n(() => import("./TnIconfrihet-Bf3p0iw1.js")),
      TnIconFrihetBasis: n(() => import("./TnIconfrihet-basis-mHORKNl6.js")),
      TnIconFrihetMaks: n(() => import("./TnIconfrihet-maks-BZdqJLbD.js")),
      TnIconFrihetPremium: n(() => import("./TnIconfrihet-premium-BDFlF-5b.js")),
      TnIconFrihetStandard: n(() => import("./TnIconfrihet-standard-ncapEy39.js")),
      TnIconHastigheti24t: n(() => import("./TnIconhastigheti24t-BmkV6i37.js")),
      TnIconHastigheti7Dager: n(() => import("./TnIconhastigheti7-dager-Ba2x4UyZ.js")),
      TnIconHastighetsreload24timer: n(() => import("./TnIconhastighetsreload24timer-CJT8kTvh.js")),
      TnIconHastighetsreload7dager: n(() => import("./TnIconhastighetsreload7dager-CW-v0rUa.js")),
      TnIconHastighetsreloadutmnd: n(() => import("./TnIconhastighetsreloadutmnd-DsYqY8A2.js")),
      TnIconHastighetutmnd: n(() => import("./TnIconhastighetutmnd-BjsXsAT6.js")),
      TnIconIngenBinding: n(() => import("./TnIconingen-binding-BfEKrIIU.js")),
      TnIconIngenTV: n(() => import("./TnIconingen-tv-BR7FQe7k.js")),
      TnIconKundeservice: n(() => import("./TnIconkundeservice-Cjioh6m_.js")),
      TnIconLegacy: n(() => import("./TnIconlegacy-BuWy6gT5.js")),
      TnIconLitt2GB: n(() => import("./TnIconlitt2-gb-DihyEmKs.js")),
      TnIconLTEM: n(() => import("./TnIconltem-D2lNx2kC.js")),
      TnIconLTEMSIM: n(() => import("./TnIconltemsim-Cn1uGgjm.js")),
      TnIconMer8GB: n(() => import("./TnIconmer8-gb-DTvuQmxN.js")),
      TnIconMinBedrift: n(() => import("./TnIconmin-bedrift-jCrBvSxx.js")),
      TnIconMinimumData: n(() => import("./TnIconminimum-data-ByH3MMoC.js")),
      TnIconMinSky: n(() => import("./TnIconmin-sky-jETZPEiO.js")),
      TnIconMittTelenor: n(() => import("./TnIconmitt-telenor-Ce3AtW3t.js")),
      TnIconMixogMatch: n(() => import("./TnIconmixog-match-CIp06cm6.js")),
      TnIconMobbefilter: n(() => import("./TnIconmobbefilter-dVRwytma.js")),
      TnIconMobiltBedriftsnett: n(() => import("./TnIconmobilt-bedriftsnett-MdVqR1Lt.js")),
      TnIconMobiltBredband: n(() => import("./TnIconmobilt-bredband-ChyUre5A.js")),
      TnIconMobiltSentralbord: n(() => import("./TnIconmobilt-sentralbord-DBnpdHRZ.js")),
      TnIconMportShop: n(() => import("./TnIconmport-shop-D5LTL0l2.js")),
      TnIconNBIoT: n(() => import("./TnIconnb-io-t-BzVA3n8q.js")),
      TnIconNbIoTSIM: n(() => import("./TnIconnb-io-tsim-D86J9HIl.js")),
      TnIconNettslett: n(() => import("./TnIconnettslett-CFC03Tf3.js")),
      TnIconNettvern: n(() => import("./TnIconnettvern-C8yp6gSI.js")),
      TnIconNettvernPluss: n(() => import("./TnIconnettvern-pluss-BFmwwliC.js")),
      TnIconNext: n(() => import("./TnIconnext-BN7Obub_.js")),
      TnIconNextFamilie: n(() => import("./TnIconnext-familie-lYUz6zPw.js")),
      TnIconNextFamilieRich: n(() => import("./TnIconnext-familie-rich-CzfP0HFT.js")),
      TnIconNextMaksimal: n(() => import("./TnIconnext-maksimal-VlhT6LGm.js")),
      TnIconNextNormal: n(() => import("./TnIconnext-normal-CM2ZXxFL.js")),
      TnIconNextRask: n(() => import("./TnIconnext-rask-BmqqybMc.js")),
      TnIconNextRich: n(() => import("./TnIconnext-rich-CwtZbsef.js")),
      TnIconNoData: n(() => import("./TnIconno-data-GlUfuHQ6.js")),
      TnIconNummervarsel: n(() => import("./TnIconnummervarsel-CXaMkHJL.js")),
      TnIconOppdatert: n(() => import("./TnIconoppdatert-BJEObuNs.js")),
      TnIconOrden: n(() => import("./TnIconorden-OX4aAouZ.js")),
      TnIconOriginal: n(() => import("./TnIconoriginal-Eej7oLV0.js")),
      TnIconOriginalRich: n(() => import("./TnIconoriginal-rich-Dx3Bf3hr.js")),
      TnIconPafyll: n(() => import("./TnIconpafyll-Da5tkAJz.js")),
      TnIconPlussforsikring: n(() => import("./TnIconplussforsikring-0iD47Tbr.js")),
      TnIconPrepaidSIM: n(() => import("./TnIconprepaid-sim-CsVencVZ.js")),
      TnIconRabatt: n(() => import("./TnIconrabatt-hWWIhTi1.js")),
      TnIconSAFE: n(() => import("./TnIconsafe-BqV8dQIN.js")),
      TnIconSAFEBasis: n(() => import("./TnIconsafe-basis-bSXnTdhg.js")),
      TnIconSAFEBasisIDvakt: n(() => import("./TnIconsafe-basis-i-dvakt-BNPUsy01.js")),
      TnIconSAFEBasisSvindelforsikring: n(() => import("./TnIconsafe-basis-svindelforsikring-jrnHoFNP.js")),
      TnIconSAFEBasisWiFi: n(() => import("./TnIconsafe-basis-wi-fi-BIzT0Aek.js")),
      TnIconSAFEIDvakt: n(() => import("./TnIconsafei-dvakt-CyI9ogL3.js")),
      TnIconSAFEIDvaktKortovervakning: n(() => import("./TnIconsafei-dvakt-kortovervakning-BR8F3gFD.js")),
      TnIconSAFEIDvaktMailovervakning: n(() => import("./TnIconsafei-dvakt-mailovervakning-xGzrFC9f.js")),
      TnIconSAFEKredittvakt: n(() => import("./TnIconsafe-kredittvakt-ClGMhkvU.js")),
      TnIconSAFESvindelforsikring: n(() => import("./TnIconsafe-svindelforsikring-BxEo0nTJ.js")),
      TnIconSAFEVPN: n(() => import("./TnIconsafevpn-BQnqG5_o.js")),
      TnIconSafeZone: n(() => import("./TnIconsafe-zone-CDmV_lM0.js")),
      TnIconSamletPlussforsikring: n(() => import("./TnIconsamlet-plussforsikring-CMQTR0pO.js")),
      TnIconSeHvem: n(() => import("./TnIconse-hvem-DfxZktiE.js")),
      TnIconSikkerID: n(() => import("./TnIconsikker-id-DCxcu3Kd.js")),
      TnIconSkjermforsikring: n(() => import("./TnIconskjermforsikring-CC_Gx8D4.js")),
      TnIconSmartFeilsoking: n(() => import("./TnIconsmart-feilsoking-C5Fc4o-r.js")),
      TnIconSvindelforsikringHusstand: n(() => import("./TnIconsvindelforsikring-husstand-CaSSQRG8.js")),
      TnIconSvindelforsikringIndivid: n(() => import("./TnIconsvindelforsikring-individ-vmQZRVgG.js")),
      TnIconSWAP: n(() => import("./TnIconswap-CQfBBPtJ.js")),
      TnIconTelefonsvar: n(() => import("./TnIcontelefonsvar-CaQ8HtIv.js")),
      TnIconTelmi: n(() => import("./TnIcontelmi-92nb57vL.js")),
      TnIconTradlostBredband: n(() => import("./TnIcontradlost-bredband-cZNvPcHz.js")),
      TnIconTryggStart: n(() => import("./TnIcontrygg-start-AF57hsOU.js")),
      TnIconTvilling: n(() => import("./TnIcontvilling-DSzVuAJ6.js")),
      TnIconTvillingSIM: n(() => import("./TnIcontvilling-sim-DqWFRd6l.js")),
      TnIconTvillingSIMDisabled: n(() => import("./TnIcontvilling-sim-disabled-CJcm1H88.js")),
      TnIconTWe: n(() => import("./TnIcont-we-CFeMWAb_.js")),
      TnIconTWeSet: n(() => import("./TnIcont-we-set-BPNjUY9v.js")),
      TnIconUbegrensetBasis: n(() => import("./TnIconubegrenset-basis-B7IJTwM0.js")),
      TnIconUbegrensetMedium: n(() => import("./TnIconubegrenset-medium-B8jh8rgT.js")),
      TnIconUbegrensetPluss: n(() => import("./TnIconubegrenset-pluss-COrnAJHP.js")),
      TnIconWiFi: n(() => import("./TnIconwi-fi-Dn7y6AWR.js")),
      TnIconWiFiModem: n(() => import("./TnIconwi-fi-modem-D_NgWG0P.js"))
    }, I = c(() => {
      if (!o.name) return null;
      const t = Object.keys(r).find((e) => e.toLowerCase() === `tnicon${o.name.toLowerCase().replace(/-/g, "")}`);
      return t ? r[t] : null;
    });
    return (t, e) => (a(), T(l(I.value), s({ fill: "none" }, t.$attrs, {
      height: i.value,
      width: i.value
    }), null, 16, ["height", "width"]));
  }
});
export {
  S as TnProductIcon
};
